export default __webpack_public_path__ + "static/media/shoes.b20ec434.svg";